import { render } from "./ClaimDetailsSidebar.vue?vue&type=template&id=9203282e"
import script from "./ClaimDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./ClaimDetailsSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__